module.exports = __webpack_public_path__ + "img/xGooglePlay2.5278705d.png";